/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type PdpRespSimilarItem_viewer = {|
  +isSeoQuicklookEnabled: ?boolean;
  +isFavoritesEnabled: ?boolean;
|};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSimilarItem_viewer",
  "selections": [
    {
      "kind": "ScalarField",
      "alias": "isSeoQuicklookEnabled",
      "args": [
        {
          "kind": "Literal",
          "name": "featureName",
          "value": "SEO_QUICKLOOK",
          "type": "String!"
        }
      ],
      "name": "isEnabledByLocale",
      "storageKey": "isEnabledByLocale{\"featureName\":\"SEO_QUICKLOOK\"}"
    },
    {
      "kind": "ScalarField",
      "alias": "isFavoritesEnabled",
      "args": [
        {
          "kind": "Literal",
          "name": "featureName",
          "value": "FAVORITES",
          "type": "String!"
        }
      ],
      "name": "isEnabledByLocale",
      "storageKey": "isEnabledByLocale{\"featureName\":\"FAVORITES\"}"
    }
  ],
  "type": "Viewer"
};

module.exports = fragment;
